export const getValidCertificadoIntegracion = (idTipoCert, itemsCertificados) => {
  const temp = itemsCertificados.find(
    (item) => item?.tipoCertificado === idTipoCert &&
      ((new Date(item?.fechaVencimiento) >= new Date() || new Date(item?.fecha2doVencimiento) >= new Date()) || 
        new Date(item?.fechaActualizacion) >= new Date()) &&
      (new Date(item?.fecha) <= new Date()) &&
      !item.fechaBaja
  );

  return temp;
}